import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Route, Switch } from 'react-router-dom';
import CookieAproval from './MenuComponents/CookieApproval';
import DefaultMenu from './DefaultMenu/DefaultMenu';
import DynamicMenu from './DynamicMenu/DynamicMenu';
import FastReOrder from './FastReOrder';
import DeliveryTracking from 'containers/DeliveryTracking';
import Settings from 'containers/Settings';
import GDPR from 'containers/GDPR';
import Header from './Header';
import SideBar from './SideBar/SideBar';
import Checkout from 'containers/Checkout';
import TeamVoucher from 'containers/TeamVoucher';
import Aux from '../../hoc/ReactAux/ReactAux';
import OptionsForOrder from './DefaultMenu/OptionsForOrder';
import ModalError from 'components/UI/Modal/ModalError';
import ModalSuccess from 'components/UI/Modal/ModalSuccess';
import OrderFeedbackCard from './OrderFeedbackCard/OrderFeedbackCard';

import queryString from 'utils/queryString';
import * as actions from 'actions/index';

class MenuBuilder extends Component {
  state = {
    feedbackAddressKey: null,
    feedbackTestCompleted: false,
  };

  componentDidMount() {
    this.props.onFetchingBusinessFromUser();
    this.onHandleVerifyRepeatOrder();
    this.onHandleInvoicePayment();
    this.fetchFeedbackForSelectedAddress();
    this.initPrint();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.addresses !== this.props.addresses) {
      this.fetchFeedbackForSelectedAddress();
    }
  }

  componentWillUnmount() {
    this.props.history.replace('/');
  }

  onHandleVerifyRepeatOrder = () => {
    let idOrderToRepeat = parseFloat(
      this.props.location.pathname.substring(
        this.props.location.pathname.lastIndexOf('/') + 1,
        this.props.location.pathname.length
      )
    );
    if (!isNaN(idOrderToRepeat)) {
      this.props.onChangeTitleHeader('Popular Dishes');
      this.handleItemArraySideBarToActive(1);
      this.props.onHandleOrderToRepeat(idOrderToRepeat);
    }
  };

  onHandleInvoicePayment = () => {
    const values = queryString.parse(this.props.location.search);
    if (values.invoice) {
      this.props.onhandleInvoiceInfo(values.invoice);
    }
  };

  onHandleSelectItemSideBar = index => {
    this.handleItemArraySideBarToActive(index);
    switch (index) {
      case 1:
        this.onHandleSelectDefaultMenu();
        break;
      case 2:
        this.onHandleFastReOrder();
        break;
      case 3:
        this.onHandleTeamVoucher();
        break;
      case 4:
        this.onHandlePlatter();
        break;
      case 5:
        this.props.toggleIsCartButtonDisabled(false);
        this.props.onToggleCart();
        break;
      case 6:
        this.onHandleDeliveryTracking();
        break;
      case 7:
        this.onHandleSettings();
        break;
      case 8:
        this.onHandleGDPR();
        break;
      case 9:
        this.onHandleLogout();
        break;
      default:
        break;
    }
    this.props.onToggleMenuMobile();
  };

  handleItemArraySideBarToActive = index => {
    let updateItemsSideBar = [...this.props.itemsSideBarMenu];
    let updateItemInactive = updateItemsSideBar.find(
      item => item.active === true
    );
    if (updateItemInactive.index !== index) {
      let updateItemActive = updateItemsSideBar.find(
        item => item.index === index
      );
      updateItemInactive.active = false;
      updateItemsSideBar[updateItemActive.index - 1] = updateItemActive;
      updateItemActive.active = true;
      updateItemsSideBar[updateItemInactive.index - 1] = updateItemInactive;
      this.props.onSelectItemSideBarMenu(updateItemsSideBar);
    }
  };

  onHandleSelectDefaultMenu = () => {
    this.props.onDeleteRestaurantSelected();
    this.props.history.replace('/Menu');
    this.initPrint();
  };

  onHandleFastReOrder = () => {
    this.props.onDeleteRestaurantSelected();
    this.props.history.replace('/Menu/FastReOrder');
  };

  onHandlePlatter = () => {
    this.props.onSelectDeliveryOption();
    this.props.onDeleteRestaurantSelected();
    this.props.history.replace('/Menu');
  };

  onHandleOptionsMenu = () => {
    this.props.history.replace('/Menu');
  };

  onHandleCheckout = () => {
    this.props.onDeleteRestaurantSelected();
    this.props.history.replace('/Menu/checkout');
  };

  onHandleTeamVoucher = () => {
    this.props.onSelectDeliveryOption();
    this.props.onDeleteRestaurantSelected();
    this.props.history.replace('/Menu/TeamVoucher');
  };

  onHandleDeliveryTracking = () => {
    this.props.onDeleteRestaurantSelected();
    this.props.history.replace('/Menu/DeliveryTracking');
  };

  onHandleSettings = () => {
    this.props.onDeleteRestaurantSelected();
    this.props.history.replace('/Menu/Settings');
  };

  onHandleGDPR = () => {
    this.props.onDeleteRestaurantSelected();
    this.props.history.replace('/Menu/GDPR');
  };

  onHandleLogout = () => {
    this.props.onLogoutRequest();
  };

  onHandleToggleRestaurantOptions = idRestaurantsOptions => {
    this.props.onChangeRestaurantOptions(idRestaurantsOptions);
    this.props.onDeleteRestaurantSelected();
  };

  onHandleSelectRestaurantDelivery = idRestaurant => {
    if (this.props.restaurantsOptions[0].active) {
      let restaurant = this.props.itemsSideBarMenu[0].restaurants.businessDelivery.find(
        business => {
          return business.id === idRestaurant;
        }
      );
      this.props.onRestaurantSelected(restaurant);
      this.props.onChangeTitleHeader(restaurant.name);
      this.props.onCategoriesSelected(restaurant.categoryType);
    } else {
      let restaurant = this.props.itemsSideBarMenu[0].restaurants.businessCollection.find(
        business => {
          return business.id === idRestaurant;
        }
      );
      this.props.onRestaurantSelected(restaurant);
      this.props.onChangeTitleHeader(restaurant.name);
      this.props.onCategoriesSelected(restaurant.categoryType);
    }
    this.props.onToggleCart(false);
    this.props.history.replace('/Menu/Dynamic');
    this.props.onVerifyRestaurantAvailable(
      idRestaurant,
      this.props.userDetails.idBusiness
    );
  };

  onHandleSelectRestaurantPlatter = idRestaurant => {
    let restaurant = this.props.itemsSideBarMenu[3].restaurants.businessPlatter.find(
      business => {
        return business.id === idRestaurant;
      }
    );
    this.props.onRestaurantSelected(restaurant);
    this.props.onCategoriesSelected(restaurant.categoryType);
    this.props.onToggleCart(false);
    this.props.history.replace('/Menu/Dynamic');
  };

  handleMenu = (idBusiness, idAddress) => {
    this.props.onFetchingMenu(idBusiness, idAddress);
  };

  handleSelectOptionForOrder = address => {
    /*Adding address for order to array of addresses */
    address.forCollection && this.props.onSelectForColectionOption();
    let addresses = [
      ...(!this.props.addresses.some(
        item => item.forCollection === address.forCollection
      ) || !!!address.forCollection
        ? [...this.props.addresses, address]
        : this.props.addresses),
    ];

    /*If address wasn't forCollection then check if there's a forCollection Address in
    fetched list if yes add it to array of addresses */
    if (!!!address.forCollection) {
      addresses = [
        ...(!!!this.props.addresses.some(item => item.forCollection) &&
        this.props.listAddress.some(item => item.forCollection)
          ? [
              ...addresses,
              this.props.listAddress.find(item => item.forCollection),
            ]
          : addresses),
      ];
    }
    this.props.onSelectAddressForOrder(addresses);
    this.props.onFetchingMenu(
      this.props.userDetails.idBusiness,
      address.idBusinessAddress
    );
    this.fetchFeedbackForAddress(address);
    this.initPrint();
  };

  fetchFeedbackForSelectedAddress = () => {
    if (!this.props.addresses || this.props.addresses.length === 0) {
      return;
    }
    this.fetchFeedbackForAddress(this.props.addresses[0]);
  };

  fetchFeedbackForAddress = address => {
    const idAddress = address && address.idBusinessAddress;
    const feedbackAddressKey = idAddress || 'default';
    if (this.state.feedbackAddressKey === feedbackAddressKey) {
      return;
    }
    this.setState({ feedbackAddressKey });
    this.props.onFetchingPendingOrderFeedback(idAddress);
  };

  isFeedbackTestMode = () => {
    const values = queryString.parse(this.props.location.search);
    return values.feedbackTest === '1';
  };

  getFeedback = () => {
    if (this.props.pendingFeedback) {
      return this.props.pendingFeedback;
    }
    if (!this.isFeedbackTestMode() || this.state.feedbackTestCompleted) {
      return null;
    }
    return {
      previousOrderId: -1,
      restaurantId: -1,
      restaurantName: this.props.titleHeader || 'Demo Restaurant Dublin',
      orderedItemsSnapshot: 'Caesar Club',
      isFeedbackTest: true,
    };
  };

  handleSubmitOrderFeedback = payload => {
    if (payload.previousOrderId === -1) {
      this.setState({ feedbackTestCompleted: true });
      return;
    }
    this.props.onSubmitOrderFeedback(payload);
  };

  handleSkipOrderFeedback = payload => {
    if (payload.previousOrderId === -1) {
      this.setState({ feedbackTestCompleted: true });
      return;
    }
    this.props.onSkipOrderFeedback(payload);
  };

  handleCreateCustomerDeliveryAddress = place => {
    this.props.onCreateCustomerDeliveryAddress(place);
  };

  showOptionsForOrder = () => {
    return this.props.restaurantsOptions[0].active
      ? this.props.listAddress.length > 0 &&
          !this.props.addresses.some(item => item.forCollection === false)
      : false;
  };

  showCollectionOption = () => {
    return (
      !this.props.addresses.find(address => address.forCollection) &&
      this.props.showCollectionOption
    );
  };

  initPrint = () => {
    var businessCollection = this.props.itemsSideBarMenu[0].restaurants
      .businessCollection;
    var businessDelivery = this.props.itemsSideBarMenu[0].restaurants
      .businessDelivery;

    if (businessCollection.length === 1 && businessDelivery.length === 0) {
      this.onHandleSelectRestaurantPlatter(businessCollection[0].id);
      this.props.onToggleMenuMobile();
    }

    if (businessDelivery.length === 1 && businessCollection.length === 0) {
      this.onHandleSelectRestaurantDelivery(businessDelivery[0].id);
      this.props.onToggleMenuMobile();
    }
  };

  render() {
    return (
      <Aux>
        <CookieAproval />
        <div className="wrap" tabIndex={0}>
          <SideBar
            goToDefaultMenu={this.onHandleSelectItemSideBar}
            activeRestaurant={this.props.restaurantSelected}
            selectItemSideBar={this.onHandleSelectItemSideBar}
            restaurantsOptions={this.props.restaurantsOptions}
            showMenuMobile={this.props.showMenuMobile}
            toggleMenuMobile={this.props.onToggleMenuMobile}
            showRestaurantsMobile={this.props.showRestaurantsMobile}
            selectRestaurantDelivery={this.onHandleSelectRestaurantDelivery}
            selectRestaurantPlatter={this.onHandleSelectRestaurantPlatter}
            itemsSideBarMenu={this.props.itemsSideBarMenu}
          />
          <div className="principal-right" tabIndex={3}>
            <Header
              showCollectionOption={this.props.showCollectionOption}
              titleHeader={this.props.titleHeader}
              itemsSideBarMenu={this.props.itemsSideBarMenu}
              toggleCart={this.props.onToggleCart}
              toggleMenuMobile={this.props.onToggleMenuMobile}
              showMenuMobile={this.props.showMenuMobile}
              goToDefaultMenu={this.onHandleSelectItemSideBar}
              restaurantSelected={this.props.restaurantSelected}
              restaurantsOptions={this.props.restaurantsOptions}
              quantityProductsSelected={this.props.products.length}
              toggleRestaurantOptions={this.onHandleToggleRestaurantOptions}
              businessId={this.props.userDetails.idBusiness}
            />
            <OptionsForOrder
              onFetchingMenu={this.handleMenu}
              idBusiness={this.props.userDetails.idBusiness}
              listAddress={this.props.listAddress}
              showModal={this.showOptionsForOrder()}
              showCollectionOption={this.showCollectionOption()}
              onToggleCart={this.props.onToggleCart}
              onDeleteAllproductsFromCard={
                this.props.onDeleteAllproductsFromCard
              }
              showDeliverAtHomeOption={this.props.showDeliverAtHomeOption}
              selectOptionForOrder={this.handleSelectOptionForOrder}
              createCustomerDeliveryAddress={
                this.handleCreateCustomerDeliveryAddress
              }
              onCartResetState={this.props.onCartResetState}
              onDeleteRestaurantSelected={this.props.onDeleteRestaurantSelected}
              onFetchingRecentlyOrdered={this.props.onFetchingRecentlyOrdered}
            />
            <ModalError
              style={{
                zIndex: '99999',
                position: 'absolute',
                margin: '5% 26%',
              }}
              showModal={this.props.showErrorModalCreateLinkVoucher}
              closeModal={() => this.props.onCloseErrorModalCreateLinkVoucher()}
              errorMessage={this.props.showMessageLinkVoucher}
              actionButtonTitle=""
            />
            <ModalSuccess
              showModal={this.props.showSuccessModalCreateLinkVoucher}
              message={this.props.showMessageLinkVoucher}
              closeModal={() =>
                this.props.onCloseSuccessModalCreateLinkVoucher()
              }
            />
            {this.props.feedbackSuccess || this.state.feedbackTestCompleted ? (
              <div className="order-feedback-success" role="status">
                Thanks — this helps us improve lunch.
              </div>
            ) : null}
            <OrderFeedbackCard
              feedback={this.getFeedback()}
              onSubmit={this.handleSubmitOrderFeedback}
              onSkip={this.handleSkipOrderFeedback}
            />

            <Switch>
              <Route exact path="/Menu" component={DefaultMenu} />
              <Route path="/Menu/Dynamic" component={DynamicMenu} />
              <Route path="/Menu/FastReOrder" component={FastReOrder} />
              <Route path="/Menu/checkout" component={Checkout} />
              <Route
                path="/Menu/DeliveryTracking"
                component={DeliveryTracking}
              />
              <Route path="/Menu/Settings" component={Settings} />
              <Route path="/Menu/GDPR" component={GDPR} />
              <Route path="/Menu/TeamVoucher" component={TeamVoucher} />
              <Route path="/Menu/ReOrder/:idOrder" component={DefaultMenu} />
            </Switch>
          </div>
        </div>
      </Aux>
    );
  }
}

const mapStateToProps = state => {
  return {
    titleHeader: state.menuReducer.titleHeader,
    restaurantsOptions: state.menuReducer.restaurantsOptions,
    userDetails: state.authenticationReducer.userDetails,
    restaurantSelected: state.menuReducer.restaurantSelected,
    itemsSideBarMenu: state.menuReducer.itemsSideBarMenu,
    products: state.cartReducer.cart.products,
    showMenuMobile: state.menuReducer.showMenuMobile,
    showRestaurantsMobile: state.menuReducer.showRestaurantsMobile,
    showCollectionOption: state.menuReducer.showCollectionOption,
    showDeliverAtHomeOption: state.menuReducer.acceptDeliverAtHome,
    listAddress: state.menuReducer.listAddress,
    addresses: state.menuReducer.addresses,
    showSuccessModalCreateLinkVoucher:
      state.landingReducer.showSuccessModalCreateLinkVoucher,
    showErrorModalCreateLinkVoucher:
      state.landingReducer.showErrorModalCreateLinkVoucher,
    showMessageLinkVoucher: state.landingReducer.showMessage,
    pendingFeedback: state.menuReducer.pendingFeedback,
    feedbackSuccess: state.menuReducer.feedbackSuccess,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onChangeTitleHeader: titleHeader =>
      dispatch(actions.changeMenuTitleHeader(titleHeader)),
    onChangeRestaurantOptions: idRestaurantsOptions =>
      dispatch(actions.changeRestaurantOptions(idRestaurantsOptions)),
    onFetchingMenu: (idBusiness, idAddress) =>
      dispatch(actions.fetchingMenu(idBusiness, idAddress)),
    onFetchingBusinessFromUser: () =>
      dispatch(actions.fetchingBusinessFromUser()),
    onSelectItemSideBarMenu: itemsSideBar =>
      dispatch(actions.selectItemSideBarMenu(itemsSideBar)),
    onLogoutRequest: () => dispatch(actions.logoutRequest()),
    onRestaurantSelected: restaurant =>
      dispatch(actions.restaurantSelected(restaurant)),
    onCategoriesSelected: categoriesSelected =>
      dispatch(actions.categoriesSelected(categoriesSelected)),
    onDeleteRestaurantSelected: () =>
      dispatch(actions.deleteRestaurantSelected()),
    onToggleCart: status => dispatch(actions.toggleCart(status)),
    onToggleMenuMobile: () => dispatch(actions.toggleMenuMobile()),
    toggleIsCartButtonDisabled: disabled =>
      dispatch(actions.toggleIsButtonDisabled(disabled)),
    onHandleOrderToRepeat: idOrder =>
      dispatch(actions.handleOrderToRepeat(idOrder)),
    onhandleInvoiceInfo: invoiceNumber =>
      dispatch(actions.fetchingInvoiceInfo(invoiceNumber)),
    onVerifyRestaurantAvailable: (idRestaurant, idBusiness) =>
      dispatch(actions.verifyRestaurantAvailable(idRestaurant, idBusiness)),
    onSelectDeliveryOption: () => dispatch(actions.changeRestaurantOptions(1)),
    onSelectForColectionOption: () =>
      dispatch(actions.changeRestaurantOptions(2)),
    onSelectAddressForOrder: address =>
      dispatch(actions.selectAddressForOrder(address)),
    onCloseSuccessModalCreateLinkVoucher: () =>
      dispatch(actions.closeSuccessModalCreateLinkVoucher()),
    onCloseErrorModalCreateLinkVoucher: () =>
      dispatch(actions.closeErrorModalCreateLinkVoucher()),
    onCreateCustomerDeliveryAddress: place =>
      dispatch(actions.createCustomerDeliveryAddress(place)),
    onDeleteAllproductsFromCard: () =>
      dispatch(actions.deleteAllProductsFromCart()),
    onCartResetState: () => dispatch(actions.cartResetState()),
    onFetchingRecentlyOrdered: idAddress =>
      dispatch(actions.fetchingRecentlyOrdered(idAddress)),
    onFetchingPendingOrderFeedback: idAddress =>
      dispatch(actions.fetchingPendingOrderFeedback(idAddress)),
    onSubmitOrderFeedback: payload =>
      dispatch(actions.submitOrderFeedback(payload)),
    onSkipOrderFeedback: payload =>
      dispatch(actions.skipOrderFeedback(payload)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MenuBuilder);



// WEBPACK FOOTER //
// ./src/containers/Menu/Menu.js